import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { aboutNextEvent, contactNextEvent, openStep, showDialog } from '../actions';
import { DispatchWithState, StringKeyValue } from '../actions/types';
import CardApplicationComponent from '../components/CardApplication/CardApplicationComponent';
import ErrorMessage from '../components/Messages/ErrorMessage';
import Receipt from '../components/Signing/Receipt';
import { AppState } from '../reducers';
import { CardsReducer } from '../reducers/cards';
import { ContextReducer } from '../reducers/context';
import { NafReducer } from '../reducers/naf';
import { StepsReducer } from '../reducers/steps';
import Dialog from './Dialog';
import LBSBankSelect from './LBSBankSelect';
import NafMemberCheck from './NafMemberCheck';
import Signing from './Signing';

interface Props {
    action: {
        contactNextEvent: (amountEnabled: boolean) => DispatchWithState;
        aboutNextEvent: () => DispatchWithState;
        openStep: (destinationStep: number) => void;
        showDialogAction: () => void;
    };
    text: StringKeyValue;
    steps: StepsReducer;
    cards: CardsReducer;
    context: ContextReducer;
    naf: NafReducer;
}

const CardApplication = (props: Props) => {
    const amountEnabled = false;
    const { context, text, steps, cards, naf } = props;
    const { contactNextEvent, aboutNextEvent, showDialogAction } = props.action;
    const { showDialog, showReceipt, showApplication, showSigning, showLBSBankSelect } = context;
    const onContactNextClick = () => {
        contactNextEvent(amountEnabled);
    };

    const onAboutYouNextClick = () => {
        aboutNextEvent();
    };
    if (showLBSBankSelect && context.appType === 'lbs') return <LBSBankSelect />;
    if (showSigning) return <Signing />;
    if (!naf.isMember && context.appType === 'naf') return <NafMemberCheck />;
    if ((showApplication && showDialog) || (showApplication && showReceipt) || (showDialog && showReceipt)) {
        return (
            <ErrorMessage
                title={text.genericErrorHeader}
                textList={[text.genericErrorText1, text.genericErrorText2, text.genericErrorText3]}
                link={text.genericErrorReturnLink}
                linkText={text.genericErrorReturnButton}
                infoBox={text.genericErrorInfoBox}
            />
        );
    }
    if (showDialog && !showApplication) return <Dialog />;
    if (showReceipt && !showApplication) return <Receipt />;

    return (
        <CardApplicationComponent
            cards={cards}
            text={text}
            steps={steps}
            onContactNextClick={onContactNextClick}
            onAboutYouNextClick={onAboutYouNextClick}
            showDialog={showDialogAction}
        />
    );
};

const mapStateToProps = (state: AppState) => ({
    text: state.context.config.data.text,
    steps: state.steps,
    cards: state.cards,
    loader: state.loader,
    context: state.context,
    naf: state.naf,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    action: bindActionCreators(
        {
            contactNextEvent,
            aboutNextEvent,
            openStep,
            showDialogAction: showDialog,
        },
        dispatch,
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CardApplication);
